import { useState } from 'react';
import FormDrawer from 'components/__new/common/form-drawer';
import { ReactComponent as HourGlass } from "assets/images/icons/project-icons/brown-hour-glass.svg"
import { useEffect } from 'react';
import { toggleFreeTrialOfferModal } from 'store/entities/payroll/payrollSetup/action';
import { useDispatch, useSelector } from 'react-redux';

const FreeTrialOfferModal = () => {
    const dispatch = useDispatch();
    const { isFreeTrialModalOpen } = useSelector((state) => state.entities.payrollSetup);
    
    // const { trialDaysLeft, trialHoursLeft, trialMinutesLeft, trialSecondsLeft } = useFreeTrial(45);

        
    // const upgradeToPaid = () => {
    //     toggleFreeTrialOfferModal();
    //     toggleSubscriptionModal();
    // }
    

    const [time, setTime] = useState({
        days: 45,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const countdownInterval = setInterval(() => {
        if (time.days === 0 && time.hours === 0 && time.minutes === 0 && time.seconds === 0) {
            clearInterval(countdownInterval);
            // call a function to handle free trial expiry
        } else {
            let updatedTime = { ...time };

            if (updatedTime.seconds > 0) {
            updatedTime.seconds--;
            } else {
            if (updatedTime.minutes > 0) {
                updatedTime.minutes--;
                updatedTime.seconds = 59;
            } else {
                if (updatedTime.hours > 0) {
                updatedTime.hours--;
                updatedTime.minutes = 59;
                updatedTime.seconds = 59;
                } else {
                if (updatedTime.days > 0) {
                    updatedTime.days--;
                    updatedTime.hours = 23;
                    updatedTime.minutes = 59;
                    updatedTime.seconds = 59;
                }
                }
            }
            }
            setTime(updatedTime);
        }
        }, 600);

        return () => clearInterval(countdownInterval);
    }, [time]);
    
    const trialDaysLeft = time.days;
    const trialHoursLeft = time.hours.toString().padStart(2, '0');
    const trialMinutesLeft = time.minutes.toString().padStart(2, '0');
    const trialSecondsLeft = time.seconds.toString().padStart(2, '0');
    
    return (
        <FormDrawer display="center" size="md" isOpen={isFreeTrialModalOpen} setIsOpen={() => dispatch(toggleFreeTrialOfferModal())}>
            <div className="p-12 max-w-md">
                <div className="flex items-center justify-center w-full">
                    <HourGlass className="w-6" />
                    <div className="text-2xl ml-2">Offer ends in</div>
                </div>
                
                <div className="flex items-start justify-center my-8">
                    <div className="free-trial-timer-wrapper-lg">
                        <h6 className="free-trial-timer-figure">{trialDaysLeft}&nbsp;:&nbsp;</h6>
                        <span className="free-trial-timer-value-lg">days</span>
                    </div>
                    
                    <div className="free-trial-timer-wrapper-lg">
                        <h6 className="free-trial-timer-figure">{trialHoursLeft}&nbsp;:&nbsp;</h6>
                        <span className="free-trial-timer-value-lg">hours</span>
                    </div>
                    
                    <div className="free-trial-timer-wrapper-lg">
                        <h6 className="free-trial-timer-figure">{trialMinutesLeft}&nbsp;:&nbsp;</h6>
                        <span className="free-trial-timer-value-lg">mins</span>
                    </div>
                    
                    <div className="free-trial-timer-wrapper-lg">
                        <h6 className="free-trial-timer-figure">{trialSecondsLeft}</h6>
                        <span className="free-trial-timer-value-lg">secs</span>
                    </div>
                </div>
                
                {/* <div className="flex items-center justify-center">
                    <button onClick={upgradeToPaid} className="btn btn-md text-sm btn-ep-primary">
                        Upgrade to Paid Plan
                    </button>
                </div> */}
            </div>
        </FormDrawer>
    )
}

export default FreeTrialOfferModal;